import { Injectable } from '@angular/core';
import { System } from './../../shared-components/System';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { YearService } from '../../shared-components/year/year.service';
import { UserService } from '../../shared-components/user/user.service';
import { LoginService } from '../login/login.service';
import { Report } from './models/report.model';
import { ReportFolder } from './models/report-folder.model';
import { ReportDefinition } from './models/report-definition.model';
import { AutoRunSnapshot } from './models/auto-run-report-snapshots.model';
import { ReportParameter } from './models/report-parameter.model';
import { ReportModule } from './models/report-module.model';
import { ClassroomSummaryService } from '../../classroom360/classroom-summary/classroom-summary.service';
import { StudentService } from '../../shared-components/student/student.service';
import { ClassroomSummary } from '../../classroom360/classroom-summary/models/classroom-summary.model';
import { Student } from '../../shared-components/student/student.model';
import { SharedService } from '../../shared-components/shared.service';
import { User } from '../../shared-components/user/user.model';
import { LoginSettings } from '../login/LoginSetting.model';
import { Lookup } from '../../shared-components/lookup/lookup.model';
import { CourseTerm } from '../../student360/student-schedule/course-term.model';
import { ReportV9 } from './models/report-v9.model';
import { formatDate } from '@angular/common';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { ReportsQueue } from './models/reports-queue.model';
import { TeacherPreview } from './models/teacher-preview.model';
import {
    GradebookStatisticalAnalysisReport,
    GradeBookAssignmentTypeBySiteSectionIds
} from './V9/gradebook-statistical-analysis-report/gradebook-statistical-analysis-report.model';
import { SchoolYearSettings } from '../../shared-components/year/school-year-settings.model';
import { DataSource } from '../reporting/models/data-source.model';
import { StudentAttachment } from '../student-attachment/student-attachment.model';
import { ReportLogos } from './models/report-logos.model';
import { Assignment } from '../../classroom360/gradebook/v9/models/assignment.model';
import { ReportBatch } from './models/report-batch.model';
import { Category } from '../../classroom360/gradebook/shared/models/category.model';
import { ReportingConfigurationSettings } from './models/reporting-configuration-settings.model';
import { V9ReportParameter } from './models/v9-report-parameter.model';

import { AutomatedTest, AutomatedTestStep, AutomatedTestArea, Element, AutomatedTestParameter, SubTestDependentTest, AutomatedTestStepQuickView } from './models/ast-element.model';

export enum v9ReportParameterName {
    strReportDate = 2 ** 1,
    strReportSiteHeader = 2 ** 2,
    strReportTitle = 2 ** 3,
    bytReportType = 2 ** 4,
    strSiteYearCode = 2 ** 5,
    lngSiteYearId = 2 ** 6,
    strStaffUserName_LNFN = 2 ** 7,
    strOutputFile_NOFILE = 2 ** 8,
    strReportTime = 2 ** 9,
    strReportSiteAddress = 2 ** 10,
    intSiteYearId = 2 ** 11,
}

export enum V9ReportName {
    AssignmentListing = 'GradeBookAssignmentListByClass',
    AttendanceHistoryByClass = 'CreateAttendanceHistoryByClass',
    CommunicationLog = 'CreateContactLog',
    DisciplineReferralList = 'ReferralListOneSIS',
    GradebookAssignmentsByStandard = 'CreateGradebookAssignmentsByObjectiveReport',
    GradeBookByClassListGridReport = 'GradeBookByClassListGridReport',
    ReportCardGradeCalculationReport = 'GradeBookFormulaCalculationReport',
    StudentGradebookIDs = 'GradeBookSISInternalIndex'
}


@Injectable()
export class ReportingService {

    // Properties
    inDebugMode = false;
    SelectedReport: Report;
    ReportFolders: ReportFolder[] = [];
    login_ID: number;
    userEmail: string;
    selectedReportFolderId: number;
    showNoFoldersMessage = false;
    snapshotDeleted = false;
    reportFolderIdToDelete: number;
    reportFolderNameToDelete: string;
    isFolderEdit = false;
    ReportFolderToEdit: ReportFolder;
    selectedFolderIds: number[] = [];
    isMyReports = false;
    isAllReports = false;
    isForSchedule = false;
    isFromMenu = false;
    allowAutoRunReport: boolean;
    maxReportSnapshotAllowed: number;
    currentUserSubscription: Subscription;
    public currentUser: User;
    public LoginSettings: LoginSettings;
    deleteReportSnapshot_ID: number;
    showReportToPDF = false;
    autoRunSnapshot: AutoRunSnapshot;
    userCanAutoRunReports: boolean;
    userHasPrivilegeAddEditDistrictReportDefinitions: boolean;
    useReportDefinitions = false;
    backgroundColorForDistrictDefinedDefinition: string; // set in constuctor if report options are turned on
    backgroundColorForUserDefinedDefinition: string; // set in constuctor if report options are turned on
    selectedCourse: ClassroomSummary;
    selectedStudent: Student;
    isReportsMenu: boolean;
    documentTypes: Lookup[] = []; // student digital content
    defaultAcademicYear: string; // = this.yearService.defaultYear.AYIdentifier;
    useParameterGroups: boolean; // so I can turn off this functionality until I get all of the parts into place -- ONE-2400
    useParameterFormatting: boolean; // so I can turn off this functionality until I get all of the parts into place -- ONE-2400
    utilizeDistributebyEmail: boolean; // ONE-4387
    isDistributebyEmail: boolean; // ONE-4387
    distributeByEmailOption_StudentSelected: boolean;
    distributeByEmailOption_PrimaryContactSelected: boolean;
    distributeByEmailOption_AllElectronicContactsSelected: boolean;
    removeArchivedFiles: boolean;
    // report archive permissions
    viewArchiveProcessesFromAllUsers: boolean;
    allowCancelArchiveProcesses: boolean;
    allowDeleteArchivedReports: boolean;
    dateFormat = /-?\d+/;
    v9parameterName = v9ReportParameterName; // parameter name enum
    v9ReportName = V9ReportName;
    skipRunningReportWhileInDebugMode = false;
    isTylerAdmin = false;
    isDebugModeInProduction = false;
    reportingConfigurationSettings: ReportingConfigurationSettings;

    reportBatch: ReportBatch;


    static saveFile(dataBase64, fileType, fileName) {
        // PRE: a base64, a file type, and a file name to set up a download
        // POST: downloads the file from the browser
        const byteCharacters = atob(dataBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: fileType });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        document.body.appendChild(a);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    }


    // Class Functions
    constructor(
        private http: HttpClient,
        private yearService: YearService,
        private userService: UserService,
        private loginService: LoginService,
        // private userPreferencesService: UserPreferencesService,
        private classroomSummaryService: ClassroomSummaryService,
        private studentService: StudentService,
        private sharedService: SharedService,
        // private gradebookV9Service: GradebookV9Service,

    ) {
        this.inDebugMode = false; // isDevMode(); // to disable in production for now
        this.skipRunningReportWhileInDebugMode = false; // this.inDebugMode;
        this.useParameterGroups = true;
        this.useParameterFormatting = true;


        this.currentUserSubscription = this.userService.observableCurrentUserStream$
            .subscribe(user => {
                this.currentUser = user;
                this.login_ID = this.currentUser.Id;
                this.userEmail = this.currentUser.Email;

                if (userService.currentUser.UserName.toLowerCase() == 'tyleradmin') {
                    this.isTylerAdmin = true;
                } else {
                    this.isTylerAdmin = false;
                }

                this.allowAutoRunReport = this.loginService.LoginSettings.AllowAutoRunReport;
                this.utilizeDistributebyEmail = this.loginService.LoginSettings.UtilizeDistributebyEmail;
                this.maxReportSnapshotAllowed = this.loginService.LoginSettings.MaxReportSnapshotAllowed;
                if (this.loginService.LoginSettings.ReportDefinitionsOption > 0) {
                    this.useReportDefinitions = true;
                }

                this.backgroundColorForDistrictDefinedDefinition = 'lavenderblush';
                this.backgroundColorForUserDefinedDefinition = 'aliceblue';

                if (!this.allowAutoRunReport) {
                    this.isMyReports = false;
                    this.isAllReports = true;
                } else {
                    this.isMyReports = true;
                }
            });


    }


    // Methods

    getReportingConfigurationSettings(schoolId: number, AYIdentifier: string): Observable<ReportingConfigurationSettings> {

        return this.http.get<ReportingConfigurationSettings>(System.apiURL.Student + 'getReportingConfigurationSettings?schoolId=' + schoolId + '&AYIdentifier=' + AYIdentifier).pipe(
            map(results => {
                results = System.convert<ReportingConfigurationSettings>(results, new ReportingConfigurationSettings());
                return results;
            })
        );

    }

    getDateWithoutTime(): Date {
        return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0);
    }

    distributeByEmail(): Observable<any> {
        return this.http.post<any>(System.apiURL.Student + 'DistributeByEmail?loginId=' + this.login_ID, this.SelectedReport);
    }


    getEmailRegexp() {
        return System.mailRegexp;
    }

    saveFolderReports(loginId: number, reportId: number, folderIds: number[]): Observable<any> {
        return this.http.post<any>(System.apiURL.Student + 'SaveFolderReports?loginId=' + loginId + '&reportid=' + reportId, folderIds);
    }

    deleteReportFolder(folderId: number): Observable<any> {
        return this.http.get<any>(System.apiURL.Student + 'DeleteReportFolder?folderId=' + folderId);
    }

    saveReportAutoRunSettings() { // SelectedReportSettings: any
        return this.http.post<any>(System.apiURL.Student + 'saveReportAutoRunSettings?loginId=' + this.login_ID, this.SelectedReport);
    }

    getReportSnapshot(snapshotId: number) {
        return this.http.get<any>(System.apiURL.Student + 'getReportSnapshot?snapshotId=' + snapshotId);
    }

    deleteReportSnapshot(snapshotId: number) {
        return this.http.post<any>(System.apiURL.Student + 'DeleteReportSnapshot?snapId=' + snapshotId, null);
    }

    getReportDefinitions(getUnsavedDefinitions: boolean): Observable<ReportDefinition[]> {
        let Login_ID_Parameter = this.login_ID;
        if (getUnsavedDefinitions && this.SelectedReport.IsDistrictReportDefinitions) {
            Login_ID_Parameter = -1;
        }
        return this.http.get<ReportDefinition[]>(System.apiURL.Student + 'GetReportDefinitions?loginId=' + Login_ID_Parameter + '&reportid=' + this.SelectedReport.Id + '&getUnsavedDefinitions=' + getUnsavedDefinitions);
    }

    saveReportOptions(parameterDefinitions: ReportDefinition[], saveHideSaveOptions: boolean): Observable<any> {
        let Login_ID_Parameter = this.login_ID;

        if (saveHideSaveOptions && this.SelectedReport.IsDistrictReportDefinitions) {
            Login_ID_Parameter = -1;
        }

        return this.http.post<any>(System.apiURL.Student + 'SaveReportDefinitions?loginId=' + Login_ID_Parameter + '&reportid=' + this.SelectedReport.Id + '&isDistrict=' + this.SelectedReport.IsDistrictReportDefinitions + '&saveHideSaveOptions=' + saveHideSaveOptions, parameterDefinitions);
    }


    saveReportFolder(folder: ReportFolder): Observable<ReportFolder[]> {
        return this.http.get<any>(System.apiURL.Student + 'saveReportFolder?userId=' + this.login_ID + '&id=' + folder.Id + '&name=' + folder.Name + '&description=' + folder.Description);

    }

    getMyReportFolders(): Observable<ReportFolder[]> {

        return this.http.get<ReportFolder[]>(System.apiURL.Student + 'GetmyReports?loginId=' + this.login_ID).pipe(
            map(results => {
                results = System.convert<ReportFolder[]>(results, new Array<ReportFolder>());
                // if no report folders, if has permissions to add folders, show message to add a folder
                const folders: ReportFolder[] = results;
                if (folders == null || folders.length == 0) {
                    this.showNoFoldersMessage = true;
                } else {
                    this.showNoFoldersMessage = false;
                }
                return results;
            })
        );
    }

    getReportModulesByRole(schoolId: number): Observable<ReportModule[]> {
        return this.http.get<ReportModule[]>(System.apiURL.Student + 'GetReportModulesByRole?loginId=' + this.login_ID + '&schoolId=' + schoolId).pipe(
            map(topLevelmodules => {
                topLevelmodules = System.convert<ReportModule[]>(topLevelmodules, new Array<ReportModule>());
                return topLevelmodules;
            })
        );
    }


    getAllReports(moduleId: number, schoolId: number): Observable<Report[]> {

        return this.http.get<Report[]>(System.apiURL.Student + 'GetReports?moduleId=' + moduleId + '&loginId=' + this.login_ID + '&schoolId=' + schoolId).pipe(
            map(reports => {
                reports = System.convert<Report[]>(reports, new Array<Report>());
                return reports;
            })
        );
    }


    getReportByIsSysGen(isSysGen: number): Observable<Report> {

        return this.http.get<Report>(System.apiURL.Student + 'GetReportByIsSysGen?loginId=' + this.login_ID + '&isSysGen=' + isSysGen).pipe(
            map(reports => {
                reports = System.convert<Report>(reports, new Report());
                return reports;
            })
        );
    }

    getReportParameters(paramId: number, report: Report, forSchedule?: boolean): Observable<Report> {

        if (forSchedule == undefined || forSchedule == null) {
            forSchedule = false;
        }

        report.UseParameterGroups = this.useParameterGroups;
        report.UseParameterFormatting = this.useParameterFormatting;

        let selectedSubjectId = 0;
        let selectedSectionId = 0;
        let selectedStudentId = 0;
        let selectedSubjectCode = '';
        let selectedSectionName = '';
        let selectedStudentNumber = '';

        if (this.selectedCourse != null && this.selectedCourse != undefined) {
            selectedSubjectId = this.selectedCourse.SubjectId;
            selectedSubjectCode = this.selectedCourse.SubjectCode;
            selectedSectionId = this.selectedCourse.SSEC_ID;
            if (this.selectedCourse.ReportingSectionName != null && this.selectedCourse.ReportingSectionName != undefined) {
                // I'm doing this check to be safe, this new field ReportingSectionName (really just the SubjectSection.SSecName) was added by Mat for ONE-5843
                selectedSectionName = this.selectedCourse.ReportingSectionName;
            } else {
                selectedSectionName = this.selectedCourse.Section;
            }
        }

        if (this.selectedStudent != null && this.selectedStudent != undefined) {
            selectedStudentId = this.selectedStudent.Id;
            selectedStudentNumber = this.selectedStudent.StudentNumber;
        }

        const urlArgs =
            '?userId=' + this.login_ID +
            '&paramId=' + paramId +
            '&ayIdentifier=' + this.yearService.defaultYear.AYIdentifier +
            '&schoolId=' + this.yearService.defaultYear.SchoolID +
            '&forSchedule=' + forSchedule +
            '&selectedSubjectId=' + selectedSubjectId +
            '&selectedSubjectCode=' + selectedSubjectCode +
            '&selectedSectionId=' + selectedSectionId +
            '&selectedSectionName=' + selectedSectionName +
            '&selectedStudentId=' + selectedStudentId +
            '&selectedStudentNumber=' + selectedStudentNumber;


        return this.http.post<Report>(System.apiURL.Student + 'GetReportParameters' + urlArgs, report).pipe(
            map(results => {
                results = System.convert<Report>(results, new Report());
                for (let i = 0; i < results.Parameters.length; i++) {
                    results.Parameters[i] = System.convert<ReportParameter>(results.Parameters[i], new ReportParameter());
                    results.Parameters[i].ParameterReportDefinition = System.convert<ReportDefinition>(results.Parameters[i].ParameterReportDefinition, new ReportDefinition());
                }

                return results;
            })
        );


    }


    runReport(): Observable<any> {
        let results;
        results = this.http.post<any>(System.apiURL.Student + 'RunReport', this.SelectedReport);
        return results;
    }


    runManualReport(isSysGen: number, queryString: string): Observable<any> {
        let results;
        results = this.http.get<any>(System.apiURL.Student + 'RunManualReport?isSysGen=' + isSysGen + '&queryString=' + queryString);
        return results;
    }


    runReportToEmail(): Observable<any> {
        let results;
        results = this.http.post<any>(System.apiURL.Student + 'SendReportPdfToEmails', this.SelectedReport);
        return results;
    }

    handleCheckboxAll(checkedDataSource: DataSource, dataSourceArray: DataSource[]) {
        //  check/uncheck when All is changed
        if (checkedDataSource.TextField == 'All' && checkedDataSource.ValueField == '-1') { //  -1 is All
            //  set the others to match All
            for (let i = 0; i < dataSourceArray.length; i++) {
                dataSourceArray[i].IsSelected = checkedDataSource.IsSelected;
            }
        }

        let firstCheckBoxIsAll = false;
        let allItemsAreChecked = true;

        if (dataSourceArray[0].TextField == 'All' && dataSourceArray[0].ValueField == '-1') {
            firstCheckBoxIsAll = true;
        }

        //  uncheck the All checkbox if ANY checkbox is unselected
        if (firstCheckBoxIsAll) {
            for (let i = 1; i < dataSourceArray.length; i++) { //  starting at index 1 instead of 0 to skip looking at All

                if (!dataSourceArray[i].IsSelected) {
                    dataSourceArray[0].IsSelected = false; //  uncheck All
                    allItemsAreChecked = false;
                    break;
                }
            }
            // check the All checkbox if ALL checkboxes are selected
            if (allItemsAreChecked) {
                dataSourceArray[0].IsSelected = true;
            }
        }
    }

    populateDataSourceFromLookup(dataSourceArray: DataSource[], lookups: Lookup[]) {
        dataSourceArray.length = 0;
        let dataSource: DataSource; //  = new DataSource();
        dataSource = new DataSource();
        dataSource.TextField = 'All';
        dataSource.ValueField = '-1';
        dataSource.Id = '-1';
        dataSourceArray.push(dataSource);
        // let myLookup: Lookup;
        for (let i = 0; i < lookups.length; i++) {
            if (lookups[i].CodeDescription == '' || lookups[i].CodeDescription == undefined) {
                continue;
            }
            dataSource = new DataSource();
            dataSource.TextField = lookups[i].CodeDescription; // lookups[i].CodeDescription;
            dataSource.ValueField = lookups[i].Code; // lookups[i].Code;
            // dataSource.IsSelected = true;
            dataSource.Id = lookups[i].Id;
            dataSourceArray.push(dataSource);
        }
    }

    hasStringValueNotEmpty(stringToCheck: string): boolean {
        if (stringToCheck != undefined && stringToCheck != '' && stringToCheck != null) {
            return true;
        } else {
            return false;
        }
    }

    minIsGreaterThanMax(min: string, max: string) {
        if (parseInt(min, 10) > parseInt(max, 10)) {
            return true;
        } else {
            return false;
        }

    }

    getMonthDayYear(date) {
        return new Date(parseInt((this.dateFormat.exec(date.toString()))[0], 10));
    }

    getSelectedItemsAsDelimitedString(datasourceArray: DataSource[], getTextField: boolean, delimiter: string, hasShowAll: boolean): string {
        let delimitedString = '';
        if (delimiter == null || delimiter == undefined) {
            delimiter = ','; // defaults to comma
        }
        let startIndex = 0;
        if (hasShowAll) {
            startIndex = 1;
        }
        for (let x = startIndex; x < datasourceArray.length; x++) {
            if (!datasourceArray[x].IsSelected) {
                continue;
            }
            if (getTextField) {
                delimitedString = delimitedString + datasourceArray[x].TextField + delimiter;
            } else {
                delimitedString = delimitedString + datasourceArray[x].ValueField + delimiter;
            }
        }
        if (delimitedString.endsWith(',')) {
            delimitedString = delimitedString.replace(/,\s*$/, ''); // remove trailing comma
        }
        return delimitedString;
    }

    setSelectedItemsFromUserPrefereneces(codesFromPreferences: string, dataSourceArray: DataSource[]) {
        const attCodesFromPreferences = codesFromPreferences.split('');
        let selectedCount = 0;
        for (let k = 0; k < attCodesFromPreferences.length; k++) {
            for (let i = 1; i < dataSourceArray.length; i++) {

                if (attCodesFromPreferences[k] == dataSourceArray[i].TextField) {
                    dataSourceArray[i].IsSelected = true;
                    selectedCount++;
                } else {
                    if (dataSourceArray[i].IsSelected == undefined) {
                        dataSourceArray[i].IsSelected = false;
                    }
                }
            }
        }
        if (selectedCount > 0 && selectedCount == dataSourceArray.length - 1) { // -1 to handle All checkbox
            dataSourceArray[0].IsSelected = true; // NEED TO SELECT THE ALL CHECKBOX
        }

    }

    getMyClasses(termId: number, viewId: number, isTeacher: boolean, includeAllCourses: boolean, dateItem: Date): Observable<ClassroomSummary[]> {
        // TODO: Fix Duplicate Service Call
        const currentDate = new Date();
        const dateString = (currentDate.getUTCMonth() + 1) + '/' + currentDate.getDate() + '/' + currentDate.getUTCFullYear();
        let queryString = '';
        queryString += '?schoolId=' + this.yearService.defaultYear.SchoolID +
            '&yearId=' + this.yearService.defaultYear.Id +
            '&termId=' + termId +
            '&viewId=' + viewId +
            '&isTeacher=' + isTeacher +
            '&dateItem=' + dateItem +
            '&includeAllCourses=' + includeAllCourses +
            '&currentDate=' + dateString;
        return this.http.get<ClassroomSummary[]>
            (System.apiURL.Classroom + 'GetMyClasses' + queryString);
    }


    getV9Reports(pageName: string): Observable<ReportV9[]> {
        const urlArgs = '?pageName=' + pageName + '&yearId=' + this.yearService.defaultYear.Id + '&schoolId=' + this.yearService.defaultYear.SchoolID;
        return this.http.get<ReportV9[]>(System.apiURL.Student + 'GetV9Reports' + urlArgs).pipe(
            map(results => {
                results = System.convert<ReportV9[]>(results, new Array<ReportV9>());
                return results;
            })
        );
    }

    getTermsforCourses(termDefinitionId: number, siteYearId: number): Observable<CourseTerm[]> {
        return this.http.get<CourseTerm[]>(System.apiURL.Counselor + 'GetTermsforCourses?termDefinitionId=' + termDefinitionId + '&siteYearId=' + siteYearId);
    }

    getGradebookTermsBySiteSectionId(siteSectionId: number, tgsId: number, showTermOnly: boolean, yearId: number, schoolId: number, userId: number): Observable<CourseTerm[]> {
        // TODO: Fix Duplicate Service Call
        const apiCallString = System.apiURL.Classroom + 'GetGradebookTermsBySiteSectionId?siteSectionId=' + siteSectionId
            + '&tgsId=' + tgsId
            + '&showTermOnly=' + showTermOnly
            + '&yearId=' + yearId
            + '&schoolId=' + schoolId
            + '&userId=' + userId;
        return this.http.get<CourseTerm[]>(apiCallString);
    }


    getDistrictDepartmentsReadForGradebookAssignmentsLookup(siteYearId: number): Observable<Lookup[]> {
        return this.http.get<Lookup[]>(System.apiURL.Student + 'GetDistrictDepartmentsReadForGradebookAssignmentsLookup?siteYearId=' + siteYearId);
    }


    getDynamicPagesReadForStudentLookup(userIsTeacher: boolean): Observable<Lookup[]> {
        // TODO: Fix Duplicate Service Call
        return this.http.get<Lookup[]>(System.apiURL.Classroom + 'GetDynamicPagesReadForStudentLookup?userIsTeacher=' + userIsTeacher);
    }

    getResidencyCodesLookup(): Observable<Lookup[]> {
        return this.http.get<Lookup[]>(System.apiURL.Student + 'GetResidencyCodeLookup');
    }

    getEnrollmentCategoriesLookup(): Observable<Lookup[]> {
        return this.http.get<Lookup[]>(System.apiURL.Student + 'GetEnrollmentCategoryLookup');
    }

    getAllGradeLevelsLookup(): Observable<Lookup[]> {
        return this.http.get<Lookup[]>(System.apiURL.Student + 'GetAllGradeLevels?yearId=' + this.yearService.defaultYear.Id + '&qrFamily=false&ayIdentifier=' + this.yearService.defaultYear.AYIdentifier);
    }

    getAttendanceCodesLookup(isTeacher: boolean, schoolId: number): Observable<Lookup[]> {
        // TODO: Fix Duplicate Service Call
        return this.http.get<Lookup[]>(System.apiURL.Counselor + 'GetAttendanceCodeLookup?IsTeacher=' + isTeacher + '&schoolId= ' + schoolId);
    }

    getGradebookAssignmentTypesLookup(siteSectionIds: string): Observable<Lookup[]> {
        return this.http.post<Lookup[]>(System.apiURL.Student + 'GetGradeBookAssignmentTypeBySiteSectionIdsLookup', siteSectionIds);
    }

    getGradebookAssignmentType(courseId: number, courseIds: string): Observable<Category[]> {
        // TODO: Fix Duplicate Service Call
        const apiCallString = System.apiURL.Classroom + 'GetGradebookAssignmentType?isTeacherUser=' + this.currentUser.UserIsTeacher      // userId=' + this.currentUser.Id
            + '&courseId=' + courseId
            + '&courseList=' + courseIds;
        return this.http.get<any>(apiCallString).pipe(
            map(assignmentTypes => {
                assignmentTypes = System.convert<Category[]>(assignmentTypes, new Array<Category>());
                for (let x = 0; x < assignmentTypes.length; x++) {
                    assignmentTypes[x].isSelected = false;
                }
                return assignmentTypes;
            })
        );

    }

    getGradebookAssignments(siteSectionId: number, assignmentTypeId: number, gradebookUnitId: number, termId: number, gradebookAssignmentId: number): Observable<Assignment[]> {
        let queryString = '';
        queryString += '?siteSectionId=' + siteSectionId +
            '&termId=' + termId +
            '&assignmentTypeId=' + assignmentTypeId +
            '&gradebookUnitId=' + gradebookUnitId +
            '&gradebookAssignmentId=' + gradebookAssignmentId;
        return this.http.get<Assignment[]>(System.apiURL.Classroom + 'GetGradebookV9Assignments' + queryString);
    }

    addCoreParametersV9(parameters: any[], reportTitle: string, reportType: number, parameterNameFlags: number) {
        const flags = v9ReportParameterName;

        /* tslint:disable:no-bitwise */
        if (flags.strReportSiteHeader & parameterNameFlags) {
            parameters.push({
                ParamName: 'strReportSiteHeader',
                ParamStringValue: this.yearService.defaultYear.SchoolName
            });
        }

        if (flags.strReportSiteAddress & parameterNameFlags) {
            parameters.push({ ParamName: 'strReportSiteAddress', ParamStringValue: '' });
        }

        if (flags.strReportDate & parameterNameFlags) {
            parameters.push({
                ParamName: 'strReportDate',
                ParamStringValue: ((new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear())
            });
        }

        if (flags.strReportTitle & parameterNameFlags) {
            parameters.push({ ParamName: 'strReportTitle', ParamStringValue: reportTitle });
        }

        if (flags.strSiteYearCode & parameterNameFlags) {
            parameters.push({
                ParamName: 'strSiteYearCode',
                ParamStringValue: this.yearService.defaultYear.SchoolCode + '' + this.yearService.defaultYear.AYIdentifier
            });
        }

        if (flags.lngSiteYearId & parameterNameFlags) {
            parameters.push({ ParamName: 'lngSiteYearId', ParamStringValue: this.yearService.defaultYear.SiteYearId });
        }

        if (flags.bytReportType & parameterNameFlags) {
            parameters.push({ ParamName: 'bytReportType', ParamStringValue: reportType });
        }

        if (flags.strStaffUserName_LNFN & parameterNameFlags) {
            parameters.push({
                ParamName: 'strStaffUserName',
                ParamStringValue: this.currentUser.LastName + ', ' + this.currentUser.FirstName
            });
        }

        if (flags.strOutputFile_NOFILE & parameterNameFlags) {
            parameters.push({ ParamName: 'strOutputFile', ParamStringValue: 'NOFILE' });
        }

        if (flags.strReportTime & parameterNameFlags) {
            parameters.push({ ParamName: 'strReportTime', ParamStringValue: new Date().toTimeString().split(' ')[0] });
        }

        if (flags.intSiteYearId & parameterNameFlags) {
            parameters.push({ ParamName: 'intSiteYearId', ParamStringValue: this.yearService.defaultYear.SiteYearId });
        }
    }

    getTodaysDate() {
        const today = new Date();
        return (today.getMonth() + 1) + '/' + today.getDate() + '/' + new Date().getFullYear();
    }

    getSelectedIdsAsCommaDelimitedString(dataSourceArray: DataSource[]): string {
        let selectedIds = '';
        for (let x = 0; x < dataSourceArray.length; x++) {
            if (dataSourceArray[x].TextField == 'All' && dataSourceArray[x].ValueField == '-1') {
                continue; // skip All checkbox
            }
            if (dataSourceArray[x].IsSelected) {
                selectedIds = selectedIds + ',' + dataSourceArray[x].Id;
            }
            if (selectedIds.startsWith(',')) {
                selectedIds = selectedIds.slice(1);
            }
        }
        return selectedIds;
    }

    openStudentAttachmentReport(documentId: number, reportName: string, documentBase64: string, documentMimeType: string, documentModuleName: string, reportParameters: any[], reportType: number) {
        const studentAttachment: StudentAttachment = {
            DocumentId: documentId,
            DocumentName: reportName,
            DocumentBase64: documentBase64,
            DocumentMimeType: documentMimeType,
            DocumentModuleName: documentModuleName,
            ReportParameters: reportParameters,
            ReportType: reportType
        };
        window.localStorage.setItem('studentAttachment', JSON.stringify(studentAttachment));
        window.open(System.baseUrl + 'studentattachment', '_blank');
    }

    getTeacherPreviewGridData(siteYearId: number, termDefinitionId: number, currentAttendanceDate: Date, startPeriod: number, endPeriod: number): Observable<TeacherPreview[]> {
        const currentAttDate = formatDate(currentAttendanceDate, 'MM/dd/yyyy', 'en-US');
        return this.http.get<TeacherPreview[]>(System.apiURL.Student + 'GetTeacherPreviewGridData?siteYearId=' + siteYearId + '&termDefinitionId=' + termDefinitionId + '&currentAttendanceDate=' + currentAttDate + '&startPeriod=' + startPeriod + '&endPeriod=' + endPeriod);
    }

    runV9Report(reportName: string, reportType: number, workflowReport: boolean, reportParameters): Observable<number[]> {
        return this.http.post<number[]>(System.apiURL.Student + 'RunV9Report?reportName=' + reportName + '&reportType=' + reportType + '&workflowReport=' + workflowReport, reportParameters);
    }

    getNumberMask() {
        return {
            guide: true,
            mask: createNumberMask({
                prefix: '',
                includeThousandsSeparator: false,
                integerLimit: 2,
                allowDecimal: false,
                decimalLimit: false
            })
        };
    }

    getReportsQueue(showAllUsers: boolean = false, schoolId = this.yearService.defaultYear.SchoolID, yearId = this.yearService.defaultYear.Id,): Observable<ReportsQueue[]> {
        const urlArgs = '?schoolId=' + schoolId + '&yearId=' + yearId + '&showAllUsers=' + showAllUsers;
        return this.http.get<ReportsQueue[]>(System.apiURL.Student + 'GetReportsQueue' + urlArgs).pipe(
            map(results => {
                results = System.convert<ReportsQueue[]>(results, new Array<ReportsQueue>());
                return results;
            })
        );
    }

    deleteReportsQueue(ReportQueueIds: number[]): Observable<number[]> {
        return this.http.post<number[]>(System.apiURL.Student + 'DeleteReportsQueue', ReportQueueIds);
    }

    public GetGradeBookSectionListReadbyTeacherId(siteYearId: number, allClasses: boolean): Observable<GradebookStatisticalAnalysisReport[]> {
        let queryString = '';
        queryString += '?siteYearId=' + siteYearId +
            '&allClasses=' + allClasses;
        return this.http.get<GradebookStatisticalAnalysisReport[]>(System.apiURL.Student + 'GetGradeBookSectionListReadbyTeacherId' + queryString);
    }

    public GetGradeBookAssignmentTypeBySiteSectionIdsLookup(siteSectionIds: any[]): Observable<GradeBookAssignmentTypeBySiteSectionIds[]> {
        return this.http.post<GradeBookAssignmentTypeBySiteSectionIds[]>(System.apiURL.Student + 'GetGradeBookAssignmentTypeBySiteSectionIdsLookup', siteSectionIds);
    }

    public getGradeCyclesReadBySiteYearIdLookup(siteYearId: number): Observable<Lookup[]> {

        return this.http.get<Lookup[]>(System.apiURL.Student + 'GetGradeCyclesReadBySiteYearIdLookup' + '?siteYearId=' + siteYearId);
    }

    public getTermGradeCycleHeaderRead(siteYearId: number, termGradeCycleId: number): Observable<any[]> {
        let queryString = '';
        queryString += '?siteYearId=' + siteYearId +
            '&termGradeCycleId=' + termGradeCycleId;
        return this.http.get<any[]>(System.apiURL.Student + 'getTermGradeCycleHeaderRead' + queryString);
    }

    public getReportCardAttendanceCodesReadBySiteYearIdLookup(siteYearId: number, tardy: boolean): Observable<any[]> {
        let queryString = '';
        queryString += '?siteYearId=' + siteYearId +
            '&tardy=' + tardy;
        return this.http.get<number[]>(System.apiURL.Student + 'getReportCardAttendanceCodesReadBySiteYearIdLookup' + queryString);
    }

    public updateGradingOptionsTemplate(userId: number, schoolYearSettings: SchoolYearSettings): Observable<any[]> {
        let queryString = '';
        queryString += '?userId=' + userId +
            '&schoolYearSettingsDTO=' + schoolYearSettings;
        return this.http.get<number[]>(System.apiURL.Student + 'updateGradingOptionsTemplate' + queryString);
    }

    public getReportLogos(userId: number, schoolId: number): Observable<ReportLogos[]> {
        let queryString = '';
        queryString += '?userId=' + userId +
            '&schoolId=' + schoolId;
        return this.http.get<ReportLogos[]>(System.apiURL.Student + 'getReportLogos' + queryString);
    }

    // REPORT BATCH

    public addReportBatch(batch: ReportBatch): Observable<ReportBatch> {
        this.SelectedReport.ReportBatch = batch;
        if (this.inDebugMode) {
            console.log(this.SelectedReport.ReportBatch);
        }

        // this.reportBatch = batch;

        // map(b => {
        //     this.SelectedReport.ReportBatch = System.convert<ReportBatch>(batch, new ReportBatch());

        // });

        let queryString = '';
        queryString += '?AyIdentifier=' + this.yearService.defaultYear.AYIdentifier;
        queryString += '&schoolDomain=' + this.yearService.defaultYear.SchoolID;
        return this.http.post<ReportBatch>(System.apiURL.Student + 'AddReportBatch' + queryString, this.SelectedReport);
    }

    public getReportBatches(): Observable<ReportBatch[]> {
        let userId: number;
        if (this.viewArchiveProcessesFromAllUsers) {
            userId = -1;
        } else {
            userId = this.currentUser.Id;
        }
        let queryString = '';
        queryString += '?userId=' + userId;
        queryString += '&schoolID=' + this.yearService.defaultYear.SchoolID;
        queryString += '&ayIdentifier=' + this.yearService.defaultYear.AYIdentifier;
        return this.http.get<ReportBatch[]>(System.apiURL.Student + 'GetReportBatches' + queryString);
    }

    public startReportBatch(report: Report): Observable<any> {

        report.ReportBatch = this.reportBatch;

        let queryString = '';
        queryString += '?userId=' + this.currentUser.Id;
        queryString += '&schoolID=' + this.yearService.defaultYear.SchoolID;
        queryString += '&ayIdentifier=' + this.yearService.defaultYear.AYIdentifier;
        return this.http.post<any>(System.apiURL.Student + 'StartReportBatch' + queryString, report);
    }

    public cancellingReportBatch(batch: ReportBatch): Observable<any> {
        let queryString = '';
        queryString += '?batchId=' + batch.Id;
        queryString += '&userId=' + this.currentUser.Id;
        queryString += '&schoolID=' + this.yearService.defaultYear.SchoolID;
        queryString += '&ayIdentifier=' + this.yearService.defaultYear.AYIdentifier;
        return this.http.post<any>(System.apiURL.Student + 'CancellingReportBatch' + queryString, batch);
    }


    public startCancelReportBatchCleanupProcess(batch: ReportBatch): Observable<any> {
        let queryString = '';
        queryString += '?batchId=' + batch.Id;
        return this.http.get<any>(System.apiURL.Student + 'StartCancelReportBatchCleanupProcess' + queryString);
    }

    public deleteReportBatch(batch: ReportBatch): Observable<any> {
        let queryString = '';
        queryString += '?batchId=' + batch.Id;
        queryString += '&userId=' + this.currentUser.Id;
        queryString += '&schoolID=' + this.yearService.defaultYear.SchoolID;
        queryString += '&ayIdentifier=' + this.yearService.defaultYear.AYIdentifier;
        return this.http.post<any>(System.apiURL.Student + 'DeleteReportBatch' + queryString, batch);
    }

    public getCurrentUserName_FNLN(): string {
        return this.currentUser.FirstName + ' ' + this.currentUser.LastName;
    }

    public getCurrentUserName_LNFN(): string {
        return this.currentUser.LastName + ' - ' + this.currentUser.FirstName;
    }

    public getCurrentUserId(): number {
        return this.currentUser.Id;
    }

    public getReportQueueQuery(report: Report): Observable<string> {
        return this.http.post<any>(System.apiURL.Student + 'GetReportQueueQuery', this.SelectedReport);
    }

    getV9ReportParameters(reportId: number, siteSectionId: number, studentId: number): Observable<V9ReportParameter[]> {
        let queryString = '';
        queryString += '?schoolId=' + this.yearService.defaultYear.SchoolID;
        queryString += '&yearId=' + this.yearService.defaultYear.Id;
        queryString += '&reportId=' + reportId;
        queryString += '&siteSectionId=' + siteSectionId;
        queryString += '&studentId=' + studentId;
        return this.http.get<V9ReportParameter[]>(System.apiURL.Student + 'GetV9ReportParameters' + queryString);
    }

    runV9ReportByParameter(schoolId: number, yearId: number, siteSectionId: number, studentId: number, report: ReportV9): Observable<number[]> {
        let queryString = '';
        queryString += '?schoolId=' + schoolId;
        queryString += '&yearId=' + yearId;
        queryString += '&siteSectionId=' + siteSectionId;
        queryString += '&studentId=' + studentId;
        System.removeIdFields(report.ReportParameters);
        return this.http.post<number[]>(System.apiURL.Student + 'RunV9ReportByParameter' + queryString, report);
    }

    getV9ReportParameterValidation(report: ReportV9): Observable<string> {
        let queryString = '';
        queryString += '?schoolId=' + this.yearService.defaultYear.SchoolID;
        queryString += '&yearId=' + this.yearService.defaultYear.Id;
        System.removeIdFields(report.ReportParameters);
        return this.http.post<string>(System.apiURL.Student + 'GetV9ReportParameterValidationMessage' + queryString, report);
    }

    getV9ReportParameterStudentNameFormat(siteSectionId: number): Observable<string> {
        let queryString = '';
        queryString += '?schoolId=' + this.yearService.defaultYear.SchoolID;
        queryString += '&yearId=' + this.yearService.defaultYear.Id;
        queryString += '&siteSectionId=' + siteSectionId;
        return this.http.get<string>(System.apiURL.Student + 'GetV9ReportParameterStudentNameFormat' + queryString);
    }

    saveReportCardMessage(report: ReportV9): Observable<any[]> {
        let queryString = '';
        queryString += '?schoolId=' + this.yearService.defaultYear.SchoolID;
        queryString += '&yearId=' + this.yearService.defaultYear.Id;
        return this.http.post<number[]>(System.apiURL.Student + 'SaveReportCardMessage' + queryString, report);
    }

    getV9ReportParameterBtnRefreshData(keyWordValue: string, report: ReportV9): Observable<V9ReportParameter> {
        let queryString = '';
        queryString += '?schoolId=' + this.yearService.defaultYear.SchoolID;
        queryString += '&yearId=' + this.yearService.defaultYear.Id;
        queryString += '&siteYearId=' + this.yearService.defaultYear.SiteYearId;
        queryString += '&keyWordValue=' + keyWordValue;
        System.removeIdFields(report.ReportParameters);
        return this.http.post<V9ReportParameter>(System.apiURL.Student + 'GetV9ReportParameterBtnRefreshData' + queryString, report);
    }

    getAutomatedTests(testId: number): Observable<AutomatedTest[]> {
        let queryString = '';
        queryString += '?testId=' + testId;
        // queryString += '&yearId=' + this.yearService.defaultYear.Id;
        return this.http.get<AutomatedTest[]>(System.apiURL.Reporting + 'GetAutomatedTests' + queryString);
    }

    getAutomatedTestSteps(testId: number): Observable<AutomatedTestStep[]> {
        let queryString = '';
        queryString += '?testId=' + testId;
        // queryString += '&yearId=' + this.yearService.defaultYear.Id;
        return this.http.get<AutomatedTestStep[]>(System.apiURL.Reporting + 'GetAutomatedTestSteps' + queryString);
    }

    saveAutomatedTest(testId: number, test: AutomatedTest): Observable<any> {
        // console.log(test);
        let queryString = '';
        queryString += '?testId=' + testId;
        // queryString += '&yearId=' + this.yearService.defaultYear.Id;
        return this.http.post<AutomatedTest>(System.apiURL.Reporting + 'SaveAutomatedTest' + queryString, test);
    }

    saveAutomatedTestSteps(testId: number, testSteps: AutomatedTestStep[]): Observable<any> {
        let queryString = '';
        queryString += '?testId=' + testId;
        // queryString += '&yearId=' + this.yearService.defaultYear.Id;
        return this.http.post<AutomatedTestStep[]>(System.apiURL.Reporting + 'SaveAutomatedTestSteps' + queryString, testSteps);
    }

    saveAutomatedTestElement(element: Element): Observable<any> {
        // queryString += '&yearId=' + this.yearService.defaultYear.Id;
        return this.http.post<Element>(System.apiURL.Reporting + 'SaveAutomatedTestElement', element);
    }

    saveAutomatedTestArea(area: AutomatedTestArea): Observable<any> {
        // queryString += '&yearId=' + this.yearService.defaultYear.Id;
        return this.http.post<AutomatedTestArea>(System.apiURL.Reporting + 'SaveAutomatedTestArea', area);
    }

    updateAutomatedTestElement(elementId: number, element: Element): Observable<any> {
        let queryString = '';
        queryString += '?elementId=' + elementId;
        return this.http.post<Element>(System.apiURL.Reporting + 'UpdateAutomatedTestElement' + queryString, element);
    }

    updateAutomatedTestArea(areaId: number, area: AutomatedTestArea): Observable<any> {
        let queryString = '';
        queryString += '?areaId=' + areaId;
        return this.http.post<Element>(System.apiURL.Reporting + 'UpdateAutomatedTestArea' + queryString, area);
    }

    getAutomatedTestAreas(testId: number): Observable<AutomatedTestArea[]> {
        let queryString = '';
        queryString += '?testId=' + testId;
        // queryString += '&yearId=' + this.yearService.defaultYear.Id;
        return this.http.get<AutomatedTestArea[]>(System.apiURL.Reporting + 'GetAutomatedTestAreas' + queryString);
    }


    getAutomatedTestElements(testId: number): Observable<Element[]> {
        let queryString = '';
        queryString += '?testId=' + testId;
        // queryString += '&yearId=' + this.yearService.defaultYear.Id;
        return this.http.get<Element[]>(System.apiURL.Reporting + 'GetAutomatedTestElements' + queryString);
    }

    deleteAutomatedTest(testId: number): Observable<boolean> {
        let queryString = '';
        queryString += '?testId=' + testId;
        // queryString += '&yearId=' + this.yearService.defaultYear.Id;
        return this.http.get<boolean>(System.apiURL.Reporting + 'DeleteAutomatedTest' + queryString);
    }

    deleteAutomatedTestStep(stepId: number): Observable<boolean> {
        let queryString = '';
        queryString += '?stepId=' + stepId;
        // queryString += '&yearId=' + this.yearService.defaultYear.Id;
        return this.http.get<boolean>(System.apiURL.Reporting + 'DeleteAutomatedTestStep' + queryString);
    }

    getV9ReportParameterSelectionByLookupName(reportParameterId: number, siteSectionId: number, reportParameterParentValueId: string, lookupProcedureName: string, studentId: number, controlType: string): Observable<V9ReportParameter> {
        let queryString = '';
        queryString += '?schoolId=' + this.yearService.defaultYear.SchoolID;
        queryString += '&yearId=' + this.yearService.defaultYear.Id;
        queryString += '&reportParameterId=' + reportParameterId;
        queryString += '&siteSectionId=' + siteSectionId;
        queryString += '&reportParameterParentValue=' + reportParameterParentValueId;
        queryString += '&lookupProcedureName=' + lookupProcedureName;
        queryString += '&studentId=' + studentId;
        queryString += '&controlType=' + controlType;
        return this.http.get<V9ReportParameter>(System.apiURL.Student + 'GetV9ReportParameterSelectionByLookupName' + queryString);
    }


    getAutomatedTestParameters(testId: number, paramId: number): Observable<AutomatedTestParameter[]> {
        let queryString = '';
        queryString += '?userId=' + this.login_ID;
        queryString += '&testId=' + testId;
        queryString += '&paramId=' + paramId;
        return this.http.get<AutomatedTestParameter[]>(System.apiURL.Reporting + 'GetAutomatedTestParameters' + queryString);
    }

    saveAutomatedTestParameter(testId: number, parameter: AutomatedTestParameter): Observable<number> {
        let queryString = '';
        queryString += '?userId=' + this.login_ID;
        queryString += '&testId=' + testId;
        queryString += '&paramId=' + parameter;
        return this.http.post<number>(System.apiURL.Reporting + 'SaveAutomatedTestParameter' + queryString, parameter);
    }

    deleteAutomatedTestParameter(testId: number, paramId: number): Observable<boolean> {
        let queryString = '';
        queryString += '?userId=' + this.login_ID;
        queryString += '&testId=' + testId;
        queryString += '&paramId=' + paramId;
        return this.http.get<boolean>(System.apiURL.Reporting + 'DeleteAutomatedTestParameter' + queryString);
    }

    getSubTestDependentTests(testId: number): Observable<SubTestDependentTest[]> {
        let queryString = '';
        queryString += '?userId=' + this.login_ID;
        queryString += '&testId=' + testId;
        return this.http.get<SubTestDependentTest[]>(System.apiURL.Reporting + 'GetSubTestDependentTests' + queryString);
    }

    getAutomatedTestQuickView(testId: number): Observable<AutomatedTestStepQuickView[]> {
        let queryString = '';
        queryString += '?userId=' + this.login_ID;
        queryString += '&testId=' + testId;
        return this.http.get<AutomatedTestStepQuickView[]>(System.apiURL.Reporting + 'GetAutomatedTestQuickView' + queryString);
    }


} // end class ReportingService
